ALLOWED_CONTROLLER = 'trouble_tickets'
ALLOWED_ACTIONS = ['index']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)
  dialog = $('*[data-selector="dialog_priority"]').dialog(autoOpen: false, width: 250)

  $('*[data-selector="select_all_trouble_tickets"]').on 'click', (e) ->
    unless $('[data-selector="select_all_trouble_tickets"]').prop('checked')
      $('input[data-selector="trouble_ticket_checkbox"]').prop('checked', false)
    else
      $('input[data-selector="trouble_ticket_checkbox"]').prop('checked', true)

  $('a[data-selector="set_priority"]').on 'click', (e) ->
    e.preventDefault()
    ids = []

    $('[data-selector="trouble_ticket_checkbox"]').each (index, element) ->
      ids.push(element.id) if element.checked

    if ids.length > 0
      $("#ids").val(ids.join())
      dialog.dialog('open')
    else
      alert("First you have to select some problem reports.")

$(document).ready(ready)
$(document).on('turbo:load', ready)
